<template>
  <div>
    <i-select
      :filterable="true"
      :clearable="true"
      :multiple="true"
      :value="value"
      :placeholder="`${is_loading ? $t('shared.loading') : $t('shared.select')}`"
      @input="input"
    >
      <i-option v-for="v in val" :key="v" :label="`${v === 'all' ? allLabel : v}`" :value="v" />

      <i-option
        v-for="(item, key) in numbers"
        :key="key"
        :label="`${item.number === 'all' ? allLabel : item.number}`"
        :value="item.number"
      />
    </i-select>
  </div>
</template>
<script>
  import { NumberService } from '@phone-number/services/NumberService';

  export default {
    props: {
      value: {
        type: Array,
        default: function () {
          return [];
        }
      }
    },
    data: () => ({
      numbers: [],
      is_loading: false
    }),
    computed: {
      val() {
        if(this.is_loading) {
          return []
        }
        return this.value?.filter((item) => this.numbers.every((n) => item != n.number));
      },

      allLabel() {
        return this.$t('voice.trunk.type.all');
      }
    },
    created() {
      this.is_loading = true;
      NumberService.getSelectByUserId(this.$user.id)
        .then((data) => {
          this.numbers = [{ number: 'all' }, ...data] || [];
          this.$emit('set_data', this.numbers);
        })
        .finally(() => (this.is_loading = false));
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
